let fotfJsonpSequence = 0;

function requestFotfJsonp(endpoint, data = {}, callbackParam = 'callback') {
  return new Promise((resolve, reject) => {
    const callbackName = `fotfJsonp_${Date.now()}_${++fotfJsonpSequence}`;
    const url = new URL(endpoint);
    for (const [key, value] of new URLSearchParams(data)) {
      url.searchParams.set(key, value);
    }
    url.searchParams.set(callbackParam, callbackName);
    url.searchParams.set('_', callbackName);

    const script = document.createElement('script');
    let settled = false;
    let timeout;
    function finish(error, response) {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      script.remove();
      if (error) {
        // A removed JSONP script may still arrive; ignore it without touching a retry.
        const cleanupTimeout = setTimeout(() => delete window[callbackName], 60000);
        window[callbackName] = () => {
          clearTimeout(cleanupTimeout);
          delete window[callbackName];
        };
        reject(error);
      } else {
        delete window[callbackName];
        resolve(response);
      }
    }

    window[callbackName] = (response) => finish(null, response);
    script.async = true;
    script.src = url.toString();
    script.onerror = () => finish(new Error('Friend of the Farm request failed'));
    script.onload = () => finish(new Error('Friend of the Farm response was invalid'));
    timeout = setTimeout(
      () => finish(new Error('Friend of the Farm request timed out')),
      15000
    );
    try {
      document.head.appendChild(script);
    } catch (error) {
      finish(error);
    }
  });
}

async function getFotfDetails(email) {
  const response = await requestFotfJsonp(
    `${storefrontApiURL}storefront/fotf/getdetails`,
    { e: email },
    'c'
  );

  const details = response?.response?.response;
  if (details?.Success !== 'true' && details?.Success !== 'false') {
    throw new Error('Friend of the Farm details response was invalid');
  }
  return {
    success: details.Success === 'true',
    response: details,
  };
}

async function submitFotfForm(formData, etAction) {
  const dataObj = Object.fromEntries(formData.entries());

  // The existing cross-origin JSONP transport submits registration as a GET.
  const response = await requestFotfJsonp(
    `${storefrontApiURL}storefront/fotf/register`,
    { ...dataObj, action: etAction }
  );

  return {
    success: response?.result === true,
    response: response || '',
    custbarcode: response?.custbarcode || '',
  };
}

async function subscribeToKlaviyo(formData) {
  let mobileNo = formatMobileNo(formData.get('mobileno'));
  let smsSubscribe = formData.get('sms_opt_in') === 'yes';
  let custBarcode = formData.get('custbarcode');
  let custBarcodeUrl = `https://apps.harrisfarm.com.au/images/barcodes/${custBarcode}.jpg`;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=Xbyprx', {
      method: 'POST',
      signal: controller.signal,
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: '2025-07-15',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: formData.get('email'),
                  phone_number: mobileNo,
                  first_name: formData.get('firstname'),
                  last_name: formData.get('lastname'),
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                    ...(smsSubscribe && {
                      sms: { marketing: { consent: 'SUBSCRIBED' } },
                    }),
                  },
                  properties: {
                    Zip: formData.get('postcode'),
                    CustomerSubCategoryCode: formData.get('storename'),
                    CustomerBarcodeURL: custBarcodeUrl,
                  },
                },
              },
            },
            custom_source: 'Friends of the Farm',
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'TU4jyM',
              },
            },
          },
        },
      }),
    });
    if (!response.ok) {
      throw new Error(`Klaviyo subscription request failed (${response.status})`);
    }
    const body = await response.text();
    return {
      success: response.status === 202,
      response: body ? JSON.parse(body) : undefined,
    };
  } finally {
    clearTimeout(timeout);
  }
}

function formatMobileNo(mobileNo) {
  if (!mobileNo) return null;
  return mobileNo.startsWith('0') ? '+61' + mobileNo.slice(1) : mobileNo;
}
